/**
 * The seal of the department. The motto inverts the real legal maxim -- de
 * minimis non curat lex, the law does not concern itself with trifles. This
 * department concerns itself with nothing else. The charge is an exclamation
 * mark, because that is what the department is for.
 */
export function Seal({ size = 88, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Seal of the Department of Complaints"
    >
      <defs>
        <path id="seal-arc-top" d="M 24,100 A 76,76 0 0 1 176,100" fill="none" />
        <path id="seal-arc-bottom" d="M 28,100 A 72,72 0 0 0 172,100" fill="none" />
      </defs>

      <circle cx="100" cy="100" r="98" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="100" cy="100" r="92" fill="none" stroke="currentColor" strokeWidth="3" />
      <circle cx="100" cy="100" r="60" fill="none" stroke="currentColor" strokeWidth="1.5" />

      <g fill="currentColor" fontFamily="'Archivo Narrow', 'Arial Narrow', sans-serif" fontWeight="600">
        <text fontSize="13.5" letterSpacing="1.6">
          <textPath href="#seal-arc-top" startOffset="50%" textAnchor="middle">
            DEPARTMENT OF COMPLAINTS
          </textPath>
        </text>
        <text fontSize="12.5" letterSpacing="2.8">
          <textPath href="#seal-arc-bottom" startOffset="50%" textAnchor="middle">
            DE MINIMIS CURAMUS
          </textPath>
        </text>
        <text x="15" y="105" fontSize="13" textAnchor="middle">★</text>
        <text x="185" y="105" fontSize="13" textAnchor="middle">★</text>
      </g>

      <path
        d="M 70,64 L 130,64 L 130,104 Q 130,131 100,144 Q 70,131 70,104 Z"
        fill="currentColor"
      />
      <g fill="var(--seal-charge, #E6EBE0)">
        <rect x="95.5" y="76" width="9" height="32" rx="2.5" />
        <circle cx="100" cy="121" r="5.2" />
      </g>
    </svg>
  )
}
